import {Component, OnInit, Optional} from '@angular/core';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormArray} from '@angular/forms';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {HhgUabCalculator, UabCostInfo} from './hhg-uab-calculator';
import {HhgUabCalculatorService} from 'src/app/services/hhg-uab-calculator/hhg-uab-calculator.service';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-hhg-uab-calculator',
    templateUrl: './hhg-uab-calculator.component.html',
    styleUrls: ['./hhg-uab-calculator.component.css'],
    standalone: false
})
export class HhgUabCalculatorComponent implements OnInit {
  hhgUabCalculatorForm: UntypedFormGroup;
  errorMessage: any;
  messageBeginMinDate: Date;
  messageEndMinDate: Date;
  isError: boolean;
  calculator: HhgUabCalculator;
  kgRateData: any;
  itemsPerPage = 10;
  updateOrDelete: boolean;
  chKg: number;
  controlId: number;
  uabType: any;
  costInfo: UabCostInfo;
  uabPct: any;
  isShowEstimation: boolean;
  closeBtnName: string;
  listChKg : number[];
  // isValidChargKg :boolean = true;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private uabcalculatorService: HhgUabCalculatorService,
              @Optional() private bsModalRef?: BsModalRef
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.resetForm();
    // this.isValidChargKg = true;
  }

  createForm() {
    this.hhgUabCalculatorForm = this.fb.group({
      uabType: new UntypedFormControl('', [Validators.required]),
      uabWeight: new UntypedFormControl('', [Validators.required]),
      uabPct: new UntypedFormControl('', [Validators.required]),
      piecedimensions: this.fb.array([this.createNewRows()])
    });
  }

  resetForm() {
    this.removeAllAdditionalRow();
    this.hhgUabCalculatorForm.controls['uabWeight'].setValue('');
    this.hhgUabCalculatorForm.controls['uabType'].setValue('International');
    this.hhgUabCalculatorForm.controls['uabPct'].setValue('');
    this.calculator = new HhgUabCalculator();
    this.calculator.totalChgKg = 0;
    this.costInfo = new UabCostInfo();
    this.isError = false;
    this.isShowEstimation = false;
    this.listChKg = [];
    // this.isValidChargKg = true;
  }

  close() {
    if (this.closeBtnName && this.closeBtnName.length > 0) {
      this.bsModalRef.hide();
    }
  }

  getData() {
    this.tmssLoader.show();
    this.isError = false;
    this.findCostInfo();
    this.uabType = this.hhgUabCalculatorForm.controls['uabType'].value;
    this.uabPct = this.hhgUabCalculatorForm.controls['uabPct'].value;
    if (this.costInfo.billKg < 45) {
      this.errorMessage = 'Billable kg must be greater than or equal to 45. Please adjust your UAB wt or peices dimensions and try again.';
      this.isError = true;
      this.tmssLoader.hide();
    } else {
      this.uabcalculatorService.getKgRate(Math.round(this.costInfo.billKg), this.uabType).subscribe(data => {
        this.kgRateData = data;
        if (this.costInfo.grossKg > this.costInfo.chargeKg) {
          this.costInfo.billKg = this.costInfo.grossKg;
        } else {
          this.costInfo.billKg = this.costInfo.chargeKg;
        }
        this.costInfo.perKg = this.kgRateData.baseRate; // =(G6*(G8/100)*G5) (Math.round(45 *1100* 1.16 )/100).toFixed(2)
        this.costInfo.billToGovt = this.costInfo.billKg * (Number(this.uabPct)/100) * this.costInfo.perKg;
        this.isShowEstimation = true;
        this.tmssLoader.hide();
      }, (error : any) => {
        this.alertService.error('There was an error while calculating the UAB cost.');
        this.tmssLoader.hide();
      });
    }
  }

  truncateNumber(value : any) {
    return value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  }

  truncateWholeNumber(value : any) {
    return Math.round(value);
  }

  findCostInfo() {
    this.costInfo = new UabCostInfo();
    this.costInfo.grossKg = (Number(this.hhgUabCalculatorForm.controls['uabWeight'].value) / 2.2046);
    this.costInfo.grossKgR = Math.round(this.hhgUabCalculatorForm.controls['uabWeight'].value / 2.2046);
    if (this.hhgUabCalculatorForm.get('piecedimensions').value.length === 0) {
      this.costInfo.chargeKg = 0;
    } else {
      this.costInfo.chargeKg = this.calculator.totalChgKg;
    }

    if (this.costInfo.grossKg > this.costInfo.chargeKg) {
      this.costInfo.billKg = this.costInfo.grossKgR;
    } else {
      this.costInfo.billKg = this.costInfo.chargeKg;
    }
  }

  calculateChKg(index: any) {
    this.calculator = new HhgUabCalculator();
    this.calculator.length = Number(this.hhgUabCalculatorForm.get('piecedimensions')['controls'][index]['controls']?.length?.value);
    this.calculator.width = Number(this.hhgUabCalculatorForm.get('piecedimensions')['controls'][index]['controls']?.width?.value);
    this.calculator.height = Number(this.hhgUabCalculatorForm.get('piecedimensions')['controls'][index]['controls']?.height?.value);
    this.chKg = (Number((this.calculator.length * this.calculator.width * this.calculator.height) / 166 * 0.4536));
    if(this.calculator){
      if(this.calculator.length && this.calculator.width && this.calculator.height){
        if(this.listChKg && this.chKg){
          this.listChKg[index] = this.chKg
        }
      }else{
        this.listChKg[index] = 0;
      }
      this.hhgUabCalculatorForm.get('piecedimensions')['controls'][index]['controls'].chargeableKg.setValue(this.chKg ? this.truncateNumber(this.chKg) :'');
      this.calculator.totalChgKg = this.listChKg.reduce(
        (preVal, curVal) => preVal + curVal,0
      )
      // this.isValidChargKg = (this.calculator.totalChgKg > 2000) ? false : true;
    }
  }

  clearPage() {
    this.resetForm();
    this.updateOrDelete = false;
  }

  addRows() {
    (this.hhgUabCalculatorForm.get('piecedimensions') as UntypedFormArray).push(this.createNewRows());
  }

  /**
   * @description creates accessorial form control in the form group array
   * @returns {FormGroup}: form group from HTML
   */
  createNewRows(): UntypedFormGroup {
    return new UntypedFormGroup({
      height: new UntypedFormControl('', [Validators.required]),
      width: new UntypedFormControl('', [Validators.required]),
      length: new UntypedFormControl('', [Validators.required]),
      chargeableKg: new UntypedFormControl(0, [Validators.required])
    });
  }

  removeSingleRow(i: number) {
    const removeElement = (this.hhgUabCalculatorForm.get('piecedimensions') as UntypedFormArray);
    if(removeElement){
      //get value at index of array before removing its.
      this.removeValueFromtotalChgKg(this.listChKg[i]);
      this.listChKg.splice(i,1);
      removeElement.removeAt(i);
    }
  }

  removeAllAdditionalRow(){
    const removeElement = (this.hhgUabCalculatorForm.get('piecedimensions') as UntypedFormArray);
    const size = (this.hhgUabCalculatorForm.get('piecedimensions') as UntypedFormArray).length;
    for (let i = size; i > 0; i--) {
      if (removeElement) {
        removeElement.removeAt(i);
      }
    }
    this.createForm();
  }

  removeValueFromtotalChgKg(item: any){
    this.calculator.totalChgKg -=  item;
  }
}

